import {
    FilterDisplayItemData,
    MakeFilterUiOject,
    YearFilterDisplayItemData,
} from '@/types';
import { TFilterGroupRangeProps } from '@/components/filters/filter-group/filter-group-slider.component';

export type TFilterGroupProps =
    | TFilterGroupOtherProps
    | TFilterGroupRangeProps
    | TFilterGroupFromToProps;
export interface TFilterGroupOtherProps {
    data:
        | FilterDisplayItemData[]
        | MakeFilterUiOject[]
        | YearFilterDisplayItemData[];
    filterType: 'radiobox' | 'checkbox' | 'multiSelect';
    filterItemClicked: (text: string) => void;
    makeModelClicked?: (vehicle: { make: string; model: string }) => void;
    label: string;
    containerExtraCssClass?: string;
}
export interface TFilterGroupFromToProps {
    data:
        | FilterDisplayItemData[]
        | MakeFilterUiOject[]
        | YearFilterDisplayItemData[];
    range?: number[];
    filterType: 'fromTo';
    rangeChanged?: (range: number[]) => void;
    label: string;
}

export function isTFilterGroupRangeProps(
    n: TFilterGroupProps
): n is TFilterGroupRangeProps {
    return (n as TFilterGroupRangeProps).filterType === 'slider';
}
export function isTFilterGroupFromToProps(
    n: TFilterGroupProps
): n is TFilterGroupFromToProps {
    return (n as TFilterGroupFromToProps).filterType === 'fromTo';
}
